import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import './App.css';
import 'react-bulma-components/dist/react-bulma-components.min.css';
import HomePhones from './Pages/HomePhones';
import DetailPhone from './Pages/DetailPhone';

function App() {
  return (
    <div>
      <Router>
        <Switch>
          <Route exact path="/"   component={HomePhones} />
          <Route path="/:id"      component={DetailPhone} />
        </Switch>
      </Router>
    </div>
  );
}

export default App;
